import React from "react";
import { useI18n } from "../i18n";
import Reveal from "../components/Reveal";
import { Database, BarChart3, Layers, Cpu, LineChart, Workflow, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ICONS = [Database, BarChart3, Layers, Cpu, LineChart, Workflow];

const Eyebrow = ({ children }) => (
  <div className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-[#00B3B3]/90 uppercase">
    <span className="h-px w-8 bg-[#00B3B3]/60" />
    {children}
  </div>
);

export default function Services() {
  const { t } = useI18n();
  return (
    <div data-testid="page-services" className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
      <Reveal><Eyebrow>{t.services.eyebrow}</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-6 font-heading font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-[1.05]">
          {t.services.title}
        </h1>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-6 text-white/60 max-w-2xl leading-relaxed">{t.services.sub}</p>
      </Reveal>

      <div className="mt-16 space-y-px bg-white/10 border border-white/10">
        {t.services.items.map((s, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <Reveal key={i} delay={i * 0.05}>
              <div className="bg-[#0a0a0a] hover:bg-[#111] transition-colors p-8 md:p-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-start group">
                <div className="md:col-span-2 flex items-center gap-4">
                  <span className="font-mono text-xs text-white/30 tracking-widest">{s.code}</span>
                  <Icon size={28} className="text-[#00B3B3]/80 group-hover:text-[#00B3B3] transition-colors" />
                </div>
                <div className="md:col-span-7">
                  <h3 className="font-heading font-bold text-2xl md:text-3xl text-white">{s.title}</h3>
                  <p className="mt-3 text-white/65 leading-relaxed max-w-2xl">{s.desc}</p>
                </div>
                <div className="md:col-span-3 flex flex-wrap gap-2 md:justify-end">
                  {s.tags.map((tag) => (
                    <span key={tag} className="font-mono text-[10px] tracking-widest text-white/60 border border-white/15 px-2 py-1">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal>
        <div className="mt-20 text-center">
          <Link
            to="/contact"
            data-testid="services-cta"
            className="inline-flex items-center gap-2 bg-[#00B3B3] text-white font-semibold px-6 py-3 rounded-sm hover:bg-[#00CCCC] transition-colors"
          >
            {t.nav.cta} <ArrowRight size={16} />
          </Link>
        </div>
      </Reveal>
    </div>
  );
}
